var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Bootstrapper } from '../common/core/bootstrapper.service';
import { MailboxTagsService } from './ticketing/mailbox-tags.service';
var BedeskBootstrapper = /** @class */ (function (_super) {
    __extends(BedeskBootstrapper, _super);
    function BedeskBootstrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BedeskBootstrapper.prototype.handleData = function (encodedData) {
        var data = _super.prototype.handleData.call(this, encodedData);
        this.injector.get(MailboxTagsService).setTags(data.tags);
        return data;
    };
    return BedeskBootstrapper;
}(Bootstrapper));
export { BedeskBootstrapper };
